import { type StoreActionApi } from 'react-sweet-state';

import type { ChatMessageResearchStore } from './types';
import { updateStep } from './updateStep';

type SetStepSourceIconsArgs = {
	messageId: string;
	stepId: string;
	sourceIcons: string[];
};

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const setStepSourceIcons: (args: SetStepSourceIconsArgs) => ChatMessageResearchStoreAction =
	({ messageId, stepId, sourceIcons }) =>
	({ dispatch }: StoreActionApi<ChatMessageResearchStore>) => {
		dispatch(updateStep({ messageId, stepId, updater: (step) => ({ ...step, sourceIcons }) }));
	};
